import { ButtonGroup, ButtonOr, Divider, Form, Button } from "semantic-ui-react";
import styled, { keyframes, css } from "styled-components";

export const StyledDivider = styled(Divider)`
color: ${props => props.theme.firstColor} !important;
margin-top: -4px !important;
`

export const StyledGroup = styled(Form.Group)`
  padding: 15px 10px;
  margin-bottom: 1.5em !important;
  gap: 35px;
  border: 1px solid rgba(34, 36, 38, 0.08);
  border-radius: 16px;
  background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  overflow: visible;
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 3px;
    background: linear-gradient(90deg, ${props => props.theme?.firstColor} 0%, ${props => props.theme?.secondColor} 100%);
  }
  
  div.marginField {
    margin-top: 1.5em !important;
  }

  .ui.selection.active.dropdown .menu {
    max-height: 15rem !important;
    z-index: 1000 !important;
    position: absolute !important;
  }

  .menu-contain {
    .ui.selection.active.dropdown .menu {
      width: 380px !important;
    }
  }

  /* Ensure dropdown menus can overflow the container */
  .ui.dropdown .menu {
    z-index: 1000 !important;
    position: absolute !important;
  }

  /* Specific styling for Select components to ensure proper overflow */
  .ui.selection.dropdown .menu {
    z-index: 1000 !important;
    position: absolute !important;
    overflow-y: scroll !important;
  }
`
export const StyledWrapper = styled.div`
padding: 20px 10px;
gap: 30px;
box-shadow: rgba(34, 36, 38, 0.15) 2px 1px 2px 1px;
border: 1px solid rgba(34,36,38,.15);
border-radius: 10px;
margin-bottom: 2em !important;

 div.marginField {
   margin-top: 1em !important;
 }
`
export const StyledButtonGroup = styled(ButtonGroup)`
 button {
  color: white !important;
 }

 button.active-step {
  background-color: ${props => props.theme?.secondColor} !important;
 }
`

export const StyledButtonOr = styled(ButtonOr)`
  &::before {
   padding-top: 9px;
    transition: 0.3s;
    font-weight: bold !important;
    border-radius: 16px 0px !important;
    color: rgb(0, 111, 165) !important;
    top: 32% !important;
    width: 3.1em !important;
    height: 3.1em !important;
    border: 1px solid rgba(108, 117, 125, 0.2) !important;
    box-shadow: rgba(0, 0, 0, 0.05) 0px 2px 4px !important;
  }
`

const fadeInUp = keyframes`
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`

const slideIn = keyframes`
  from {
    transform: translateX(-100%);
    opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
`

const shimmer = keyframes`
  0% {
    background-position: -200px 0;
  }
  100% {
    background-position: calc(200px + 100%) 0;
  }
`

const pulse = keyframes`
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0.7;
  }
`

export const TabContainer = styled.div`
  animation: ${fadeInUp} 0.6s ease-out;
`

export const StyledTabButton = styled(Button) <{ disabled?: boolean }>`
  && {
    position: relative;
    overflow: hidden;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    transform: translateY(0);
    
    &:before {
      content: '';
      position: absolute;
      top: 0;
      left: -100%;
      width: 100%;
      height: 100%;
      background: linear-gradient(
        90deg,
        transparent,
        rgba(255, 255, 255, 0.2),
        transparent
      );
      transition: left 0.5s;
    }
    
    &:hover:not(.active-step):not(:disabled) {
      box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
      
      &:before {
        left: 100%;
      }
    }
    
    &.active-step {
      background-color: ${props => props.theme?.secondColor} !important;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
      transform: scale(1.02);
    }
    
    &:disabled {
      opacity: 0.7;
      cursor: not-allowed;
    }
  }
`

export const TabContent = styled.div<{
  isTransitioning: boolean;
  activeStep: number;
}>`
  position: relative;
  min-height: 500px;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  
  ${props => props.isTransitioning && css`
    transform: translateX(10px);
    opacity: 0.8;
  `}
  
  ${props => !props.isTransitioning && css`
    animation: ${slideIn} 0.4s ease-out;
  `}
`
export const HarvestingWrapper = styled(Form.Field)`
  .disable-harvest-method {
    opacity: 0.7 !important;
  }
`